export const BREADCRUMBS_IDS = {
  address: "customer-address",
  create: "customer-create",
  details: "customer-details",
  dynamicBeneficiariesCreate: "dynamic-beneficiaries-create",
  dynamicBeneficiariesList: "dynamic-beneficiaries-list",
  edit: "customer-edit",
  list: "customers",
  paymentConfiguration: "payment-configuration",
};
